import { useDataObjectActionHandlers } from '../data-objects/useDataObjectActionHandlers';
import { OUTPUT_DATA_OBJECT_ROUTES } from './OutputDataObjects';
import { DataObjectClone } from '../data-objects/DataObjectClone';
import { DataObjectView } from '@atlas-frontend/sdk';

export const OutputDataObjectClone = () => {
  const { handleSuccess, handleCancel } = useDataObjectActionHandlers(
    'outputDataObjectView'
  );

  return (
    <DataObjectClone
      routes={OUTPUT_DATA_OBJECT_ROUTES}
      view={DataObjectView.OUT}
      onSuccess={handleSuccess}
      onCancel={handleCancel}
    />
  );
};
